import { render } from "./Matrix.vue?vue&type=template&id=9ef13d3e&scoped=true"
import script from "./Matrix.vue?vue&type=script&lang=js"
export * from "./Matrix.vue?vue&type=script&lang=js"

import "./Matrix.vue?vue&type=style&index=0&id=9ef13d3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef13d3e"]])

export default __exports__